import Vuex from 'vuex'
import Vue from 'vue'
import security from './modules/security'
import config from './modules/config'
import types from './modules/types'
import utils from './modules/utils'
import lists from './modules/lists'
import itinerario from './modules/itinerario'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    security,
    config,
    types,
    utils,
    lists,
    itinerario
  },
  strict: false
})



// WEBPACK FOOTER //
// ./src/front/store/index.js